<script>
import expenses from '../components/worker/expenses'
import orders from '../components/worker/orders'
import { mapState } from 'vuex'

export default {
    name:'worker',
    data(){
        return{
            activeName:'money',
            loading:true,
            pointRecord:[],
            lists:[],
            exc: ''
        }
    },
    components:{
        expenses,
        orders
    },
    computed:{
        ...mapState('worker',['worker'])
    },
    async created(){
        await this.pointChangeRecord();
        await this.groupOrderRecord();
        this.loading = false
    },
    methods:{
        pointChangeRecord(){
            let {group_id,member_id} = this.$route.params;
            this.yum('company/Member/pointChangeRecord',{member_id:member_id}).then(res=>{
                if(res.data.status ===200){
                    this.pointRecord = res.data.data.data,
                    this.exc = res.data.exchange | '100.00'
                }else{
                    this.$message({
                        type:'warning',
                        message:res.data.msg
                    })
                }
            })
        },
        // company/Member/groupOrderRecord
        groupOrderRecord(page){
            let {group_id,member_id} = this.$route.params;
            this.yum('company/Member/groupOrderRecord',{member_id:member_id,page:page})
            .then(res=>{
                if(res.data.status ===200){
                    this.lists = res.data.data.data
                }else{
                    this.$message({
                        type:'warning',
                        message:res.data.msg
                    })
                }
            })
        }
    }
}
</script>

<template>
    <div class="worker">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:'/member'}">员工列表</el-breadcrumb-item>
            <el-breadcrumb-item>员工信息</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <p style="font-size: 18px;color: #09153d;margin-bottom: 10px" class="bold">员工信息</p> -->
        <!-- <p class="sub-title bold">员工信息：</p> -->
        <div class="provide-detail"
        style="margin-top:20px"
        >
            <el-row>
                <el-col :span="8">员工姓名：{{worker.username}}</el-col>
                <el-col :span="8">手机号码：{{worker.mobile}}</el-col>
                <el-col :span="8">状态：{{worker.status==1?'已启用':'已停用'}}</el-col>
            </el-row>
        </div>
        <el-tabs v-model="activeName" >
            <el-tab-pane label="消费明细" name="money" >
                <expenses
                v-loading="loading"
                :pointRecord="pointRecord"
                :exc="exc"
                ></expenses>
            </el-tab-pane>
            <el-tab-pane label="订单状况" name="order" >
                <div class="orders" v-loading="loading">
                    <orders 
                    v-for="(item,key) in lists"
                    :key="key"
                    :order_info="item"
                    ></orders> 
                    <div class="nothing" v-if="lists.length==0">
                        <p><i class="el-icon-question "></i>暂无订单记录</p>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>    
    </div>    
</template>

<style lang="stylus" scoped>
.worker
    display flex
    flex-direction column
    height 100%
    .el-tabs 
        flex 1
.provide-detail
    width 750px
    margin 0 auto
    .el-row
        margin-bottom 18px
.orders
    height 650px
    overflow auto
.nothing
    color #ccc
    font-size 36px
    text-align center
    height 100%
    padding-top 200px
</style>
